import { DefaultTheme } from 'styled-components'

export const theme: DefaultTheme = {
  colors: {
    purple: '#8652FF',
    lightPurple: '#9879D2',
    text: '#3E3E3E',
    gray: '#C7C7C7',
    darkGray: '#8a8a8a',
    error: '#f74b55',
  },
}
